//include 9
jQuery(function () {
    $(".open-map-link").each((index, element) => {
        var url = $(element).attr('href');
        var className = $(element).data('open-map-class');

        if (!url)
            return;

        $(element).on("click", e => {

            var urlParameters = {};
            if(!!readCookie("pp_allow_third_party_cookies")){
                urlParameters.pp_allow_third_party_cookies = 1;
            }
            if(!!readCookie("pp_allow_analytics_cookies")){
                urlParameters.pp_allow_analytics_cookies = 1;
            }
            url = window.pixelpoint.utilities.addUrlParameters(url, urlParameters);

            //25.01.2021 - from now on we open the map every time in a new tab
            /*
            if (!window.pixelpoint.isMobile.any()) {
                e.preventDefault();
                var instance = lity(url);
                var title = $(element).data("close-button-title") || "Karte schließen";
                instance.element().attr("title", title);
                instance.element().find("iframe").attr("allow","geolocation");
                if (!!className)
                    instance.element().addClass(className);
            }
             //*/
        });
    });
});